import { render, staticRenderFns } from "./BoutiqueGrid.vue?vue&type=template&id=45b7614c&"
import script from "./BoutiqueGrid.vue?vue&type=script&lang=js&"
export * from "./BoutiqueGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BoutiqueExerpt: require('/opt/build/repo/components/BoutiqueExerpt.vue').default})
